import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import type { UiTheme } from "../theme";

// The line above a heat cell's value: the band glyph (W/M/H/X) at the left, one
// optional mark (the ✓, the «by hand» pencil) at the right. It is IN FLOW, a row
// of its own: the cell grows to hold it, so the glyph can never ride over a
// value however many characters that has or however big the font is (an
// absolutely placed glyph covered the 7 of «76.5», 15/10). Shared by the three
// heat cells (GridCell, RoundGridCell, PlanIntensityMatrix), so the fix is one.
export function CellMarks({
  theme,
  glyph,
  ink,
  right,
  size = "sm",
  weight = "800",
}: {
  theme: UiTheme;
  /** The band's letter; "" keeps the right mark at the right. */
  glyph: string;
  ink: string;
  right?: ReactNode;
  size?: "xs" | "sm";
  weight?: "700" | "800";
}) {
  return (
    <View
      style={styles.marks}
      importantForAccessibility="no-hide-descendants"
      accessibilityElementsHidden
    >
      <Text style={{ color: ink, fontSize: theme.typography.sizes[size], fontWeight: weight }}>
        {glyph}
      </Text>
      {right}
    </View>
  );
}

const styles = StyleSheet.create({
  marks: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
});
